jQuery($ => {
    // faq - show content on click
    const faqItem = $('.e-faq__header');
    faqItem.on('click', function (e) {
        const mainEl = $(this).parent();

        mainEl.toggleClass('open');
        mainEl.find(".e-faq__answer").slideToggle(300);
    });

    // news - show news summary on click
    const newsItem = $('.e-news-summary__button');
    newsItem.on("click", function(e) {
        e.preventDefault();
        const mainEl = $(this).parent();
        mainEl.toggleClass('open');
        mainEl.find(".e-news-summary__content").slideToggle(300);
    });
});
